<template>
  <component
    v-bind = "containerTag.props"
    :is = "containerTag.name">
    <slot name = "before-name" />
    <component
      v-bind = "{...parrierTag.props, ...customBind.name || {} }"
      :is = "parrierTag.name">
      <v-text-field
        v-bind = "{ ...customBind.nameInput || {} , ...textFieldProps}"
        v-model = "input.name"
        placeholder = "Campaign Name"
         />
    </component>
     <slot v-if = "!put" name = "before-app" />
    <component
      v-if = "!put"
      v-bind = "{...parrierTag.props, ...customBind.app || {} }"
      :is = "parrierTag.name">
      <v-select
        v-model = "input.app"
        :items = "apps"
        item-text = "phone_number"
        :item-value = "v => v"
        no-data-text = "No Apps for this channel"
        placeholder = "Select App"
        
        outline />
    </component>
    <slot v-if= "!put" name="before-template" />
    <component
      v-if="!put"
       v-bind = "{...parrierTag.props, ...customBind.app || {} }"
      :is = "parrierTag.name">
      <v-select
          v-model="input.message"
          :items="templateMessagesOptions"
          placeholder="Template Message"
          item-text="text"
          item-value="value"
          outline
           />
    </component>
    <slot
      v-for = "(slot, s) in new Array(slots)"
      :name = "`tail-slot-${ s + 1 }`" />
  </component>
</template>

<script>
export default {
  name: 'AddCampaign',
  props: {
    containerTag: {
      type: Object,
      default() {
        return {
          name: 'div',
          props: {
            class: ''
          }
        }
      }
    },
    parrierTag: {
      type: Object,
      default() {
        return {
          name: 'div',
          props: {
            class: ''
          }
        }
      }
    },
    textFieldProps: {
      type: Object,
      default() {
        return {
          outline: true
        }
      }
    },
    slots: {
      type: Number,
      default: 2
    },
    customBind: {
      type: Object,
      default() {
        return {}
      }
    },
    put: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      isValid: false,
      apps: [],
      input: {
        name: '',
        channel: 'whatsapp',
        message_type: 'OUTBOUND',
        app: null,
        message: null
      }
    }
  },
  watch: {
    put(val) {
      if (val) this.input = val
      else this.resetForm()
    }
  },
  mounted() {
    this.getApps()
    this.$root.$on('add-campaign-inits', inits => {
      let payload = this.$_.cloneDeep(inits)
      payload.app = this.apps.filter(a => a.app_id === payload.app.id)[0]
    	this.input = payload
      this.input = this.$_.pick(this.input, ['name', 'channel', 'message_type', 'app', 'message'])
      this.input.channel = 'whatsapp'
    })
    this.getTemplateMessages()
  },
  computed: {
    botId() {
      return this.$store.state.bot.botId
    },
    templateMessagesOptions() {
      if(!this.input.app) return []
      return this.$store.state.campaigns.templateMessages
      .filter(t => t.status === 'APPROVED' && t.app.id === this.input.app.app_id)
      .map(t => ({ text: `${t.name} (${t.status})`, value: t._id }))
    },
  },
  methods: {
    getApps() {
      this.input.app = null
      const botId = this.$store.state.bot.botId
      this.$http_chat.get(`/bots/${this.botId}/apps/smooch/list`).then(res => {
        this.apps = res.data.smooch_apps.filter(a => a && a.status === 'connected')
      })
    },
    getTemplateMessages() {
      this.$store.dispatch('templatemessages/get', null).catch(err => {
        this.$store.dispatch('setErrorMessage', true)
      })
      this.$store.dispatch('templatesettings/get', null).catch(err => {
        this.$store.dispatch('setErrorMessage', true)
      })
    },
    submit() {
      if (this.input.name.length && this.input.channel.length && this.input.app) {
        this.emitLoading(true)
        const botId = this.$store.state.bot.botId
        const formPayload = this.put ? { name: this.put.name, id: this.put._id } : { ...this.input, bot_id: this.$store.state.bot.botId }
        let payload = {
        	bot_id: botId,
        	...formPayload
        }
        if(!this.put) {
          payload.app = {
          name: payload.app.name,
          provider: 'smooch',
          id: payload.app.app_id,
          phone_number: payload.app.phone_number,
        }
        }
        this.$store.dispatch(`campaigns/${this.put ? 'update' : 'add'}`, payload)
        .then((response)=>{
          this.resetForm()
          this.emitLoading(false)
          this.$emit('success', response.data)
        })
        .catch((err) => {
          this.emitLoading(false)
          const msg = err.response && err.response.data && err.response.data.message
            ?  err.response.data.message : true
          this.$store.dispatch('setErrorMessage', msg);
          this.$emit('error', err)
        })
      }
    },
    async resetForm() {
      this.input = {
        name: '',
        channel: 'whatsapp',
        message_type: "INBOUND",
      }
      return true
    },
    emitLoading(status = true) {
      this.$emit('loading', status)
    }
  }
}
</script>

<style lang="css" scoped>
.platform-wrapper {
  border-radius: 50%;
  padding: 5px;
  height: 30px;
  width: 30px;
  
  font-size: 20px;
}
</style>
